import React, {useContext} from 'react';

const CustomerContext = React.createContext();

export const useCustomerContext = () => useContext(CustomerContext);

export default CustomerContext;
